import { Skeleton, Typography } from "@mui/material";
import { memo } from "react";
import {
  Box,
  ContentRepeater,
  FlexColBox,
} from "../../../../common/components";
import { spacing } from "../../../../styles/theme";
import { useThemeBreakpoints } from "../../../../utils/themeUtils";

const ColorSelectSkeleton = () => {
  const { isMobile } = useThemeBreakpoints();
  return (
    <FlexColBox gap={"4px"}>
      <Typography
        variant={isMobile ? "actionBoldSmallIcon" : "textRegularBold"}
      >
        <Skeleton variant="text" width={50} height={24} sx={{ mb: "4px" }} />
      </Typography>
      <Box>
        <ContentRepeater repeatCount={2}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            mb={spacing.smallDesktop}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              gap={{ xs: spacing.smallMobile, lg: spacing.smallDesktop }}
            >
              <Skeleton variant="rounded" width={22} height={22} />
              <Skeleton variant="text" width={100} height={24} />
            </Box>
            <Skeleton variant="rounded" width={22} height={22} />
          </Box>
        </ContentRepeater>
      </Box>
    </FlexColBox>
  );
};

export default memo(ColorSelectSkeleton);
